import styled from "styled-components";

export const SelectionLayout = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`;

export const Sidebar = styled.aside`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;

  @media (max-width: 768px) {
    padding: 8px;
    margin-bottom: 12px;
  }
`;

export const SidebarTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 1.1rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const UserList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const UserItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  cursor: pointer;
  background: ${({ active }) => (active ? "#e6f0ff" : "white")};
  border: 1px solid ${({ active }) => (active ? "#5a9cff" : "#ddd")};

  @media (max-width: 768px) {
    padding: 6px 8px;
    font-size: 0.9rem;
  }
`;

export const ScoreTag = styled.span`
  font-weight: 600;
  color: #333;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const MainPanel = styled.section`
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  padding: 16px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 6px;
  }
`;

export const TabButton = styled.button`
  padding: 8px 12px;
  border: 1px solid ${({ active }) => (active ? "#0077cc" : "#ccc")};
  background: ${({ active }) => (active ? "#e8f4ff" : "#f7f7f7")};
  color: ${({ active }) => (active ? "#004a80" : "#333")};
  border-radius: 6px;
  cursor: pointer;

  @media (max-width: 768px) {
    flex: 1;
    font-size: 0.9rem;
    padding: 6px 8px;
  }
`;

export const GamesList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;

export const GameCard = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  background: #f9f9f9;

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 0.9rem;
  }
`;

export const GameHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    flex-direction: column;
    gap: 4px;
  }
`;

export const PickButtons = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 6px;
  }
`;

export const PickButton = styled.button`
  padding: 8px 12px;
  border-radius: 6px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  color: #222;

  /* Default */
  border: 1px solid #bbb;
  background: #fff;

  /* Selected (before game) */
  ${({ selected }) =>
    selected &&
    `
      border-color: black;
      background: #00adccff;
    `}

  /* Correct pick */
  ${({ correct }) =>
    correct &&
    `
      border-color: #2e7d32;
      background: #c8f7c5;
      font-weight: bold;
    `}

  /* Incorrect pick */
  ${({ incorrect }) =>
    incorrect &&
    `
      border-color: #c62828;
      background: #ffd6d6;
      font-weight: bold;
    `}

  /* Winner highlight when no pick was made */
  ${({ winner }) =>
    winner &&
    `
      border-color: #c8f7c5;
      background: #dbeaff;
      font-weight: bold;
    `}

  &:hover {
    background: ${({ disabled }) => (disabled ? "#fff" : "#eee")};
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 6px 8px;
    width: 100%;
  }
`;


export const SaveBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const SaveButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  background: ${({ disabled }) => (disabled ? "#aaa" : "#0077cc")};
  color: white;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  @media (max-width: 768px) {
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
  }
`;

export const LockNotice = styled.div`
  margin: 12px 0;
  padding: 10px;
  background: #fff6e6;
  border: 1px solid #ffd699;
  border-radius: 6px;
  color: #7a5200;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
